import React, { useState, useEffect } from 'react';
import { useTranslation } from 'next-i18next';

import Link from 'next/link';
import Image from 'next/image';
import ButtonSecondary from '../ButtonSecondary';
import styles from './OfferHero.module.scss';
import { trackContactLead } from '../../utils/dataLayer';
import classNames from 'classnames';

const OfferHero = ({ titleTop, titleBottom, text, tagline, links = [] }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    const { t } = useTranslation();

    const titleClasses = classNames(styles['Title'], 'grid', { [styles['Visible']]: isVisible });
    const titleMobileClasses = classNames(styles['TitleMobile'], {
        [styles['Visible']]: isVisible,
    });
    const contentClasses = classNames(styles['Content'], 'grid', {
        [styles['Visible']]: isVisible,
    });
    const buttonsClasses = classNames(styles['Buttons'], 'grid', {
        [styles['Visible']]: isVisible,
    });
    const taglineClasses = classNames(styles['Tagline'], 'grid', {
        [styles['Visible']]: isVisible,
    });

    return (
        <section className={styles['Root']}>
            <h1 className={taglineClasses}>
                <span className={styles['TaglineText']}>{tagline}</span>
            </h1>
            <div className={titleMobileClasses}>
                <div className={titleClasses}>
                    <div className={styles['TitleContainer']}>
                        <span className={styles['TitleTop']}>{titleTop}</span>{' '}
                        <span className={styles['TitleBottom']}>{titleBottom}</span>
                    </div>
                </div>
            </div>
            <div className={styles['TitleDesktop']}>
                <div className={titleClasses}>
                    <span className={styles['TitleTop']}>{titleTop}</span>
                    <span className={styles['TitleBottom']}>{titleBottom}</span>
                </div>
            </div>
            <div className={contentClasses}>
                <p className={styles['Text']}>{text}</p>
            </div>
            <div className={buttonsClasses}>
                <div className={styles['ButtonContainer']}>
                    <ButtonSecondary
                        asLink
                        href="#footer-contact"
                        onClick={(e) => {
                            trackContactLead('Offer Hero');
                            e.preventDefault();
                            document.getElementById('footer-contact').scrollIntoView({
                                behavior: 'smooth',
                            });
                        }}
                        modifiers={['InlineFlex', 'IconRotate45']}
                        icon="icon-arrow-right-white">
                        {t('Generic.contactUs')}
                    </ButtonSecondary>
                </div>
                <ul className={styles['Links']}>
                    {links.map(({ label, anchor }) => {
                        return (
                            <li key={anchor} className={styles['ListItem']}>
                                <Link href={anchor} legacyBehavior>
                                    <a
                                        onClick={(e) => {
                                            e.preventDefault();
                                            const el = document.getElementById(anchor.replace('#', ''));
                                            el.setAttribute('tabindex', 0);
                                            el.focus();
                                            el.style.outline = 0;
                                            el.setAttribute('tabindex', -1);
                                            el.scrollIntoView({
                                                behavior: 'smooth',
                                            });
                                        }}
                                        className={styles['Link']}>
                                        {label}
                                        <Image
                                            width={20}
                                            height={20}
                                            src="/img/icon-arrow-right-white.svg"
                                            alt=""
                                            className={styles['Arrow']}
                                        />
                                    </a>
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </section>
    );
};

OfferHero.propTypes = {};

export default OfferHero;
